import { RouteConfig } from "vue-router";

import { Network } from "@/network";

const MaterialsRoute: Array<RouteConfig> = [
  {
    path: "/materials",
    component: () => import("@/views/ap/materials/Index.vue"),
    beforeEnter: (to, from, next) => {
      if (Network.authCheck()) {
        next();
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/materials/print",
    name: "materialsPrint",
    component: () => import("@/views/ap/materials/Print.vue"),
    props: true
  },
  // 20230223 整合二階 另開材質展示
  {
    path: "/materials/display",
    component: () => import("@/views/ap/materials/MaterialsPhase3.vue"),
    beforeEnter: (to, from, next) => {
      if (Network.authCheck()) {
        next();
      } else {
        next("/login");
      }
    }
  },
  //20230616
  // {
  //   path: "/materials/pdf",
  //   component: () => import("@/views/ap/materials/PDF.vue"),
  // }
];

export { MaterialsRoute };
